import { IBrief } from "@shared/lib/types/brief";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface useCampaignState {
  campaignId: string;
  campaign?: IBrief;
}

interface useCampaignActions {
  setCampaign: (campaign: IBrief, id: string) => void;
  reset: () => void;
}

const getInitialState = (): useCampaignState => ({
  campaignId: "",
  campaign: undefined,
});

export const useCampaignStore = create<useCampaignState & useCampaignActions>()(
  devtools((set, get) => ({
    ...getInitialState(),
    reset: () => {
      set({ ...getInitialState() });
    },
    setCampaign: (campaign: IBrief, id: string) => {
      set({ campaign, campaignId: id });
    },
  }))
);
